(function () {
  var parallaxElements = Array.prototype.slice.call(document.querySelectorAll('.parallax'));
  var ticking = false;
  var resizeTicking = false;

  if (!parallaxElements.length) {
    return;
  }

  function getScaleAmount(element) {
    var raw = Number(element.getAttribute('data-scale'));
    if (!Number.isFinite(raw) || raw < 0) {
      return 1;
    }
    return raw;
  }

  function updateParallaxElementSize(element) {
    var img = element.querySelector('img');
    var wrapperHeight;
    var wrapperWidth;
    var imageAspectRatio;
    var requestedScale;
    var newHeight;

    if (!img || !img.naturalWidth || !img.naturalHeight) {
      return;
    }

    wrapperHeight = element.offsetHeight;
    wrapperWidth = element.offsetWidth;
    imageAspectRatio = img.naturalHeight / img.naturalWidth;
    requestedScale = getScaleAmount(element);

    newHeight = Math.max(
      Math.round(wrapperHeight * (1 + requestedScale)),
      Math.round(wrapperWidth * imageAspectRatio)
    );

    if (img.dataset.parallaxHeight !== String(newHeight)) {
      img.style.height = String(newHeight) + 'px';
      img.dataset.parallaxHeight = String(newHeight);
    }
  }

  function updateParallaxElementPosition(element, viewportHeight) {
    var img = element.querySelector('img');
    var rect;
    var wrapperHeight;
    var wrapperRange;
    var wrapPos;
    var isVisible;
    var imgHeight;
    var amount;
    var offset;
    var precision;

    if (!img) {
      return;
    }

    rect = element.getBoundingClientRect();
    wrapperHeight = element.offsetHeight;
    wrapperRange = viewportHeight + wrapperHeight;
    wrapPos = Math.max(rect.top + wrapperHeight, 0);
    isVisible = wrapPos <= wrapperRange && wrapPos >= 0;

    if (!isVisible) {
      return;
    }

    imgHeight = img.offsetHeight;
    amount = Math.min(wrapPos, wrapperRange) / wrapperRange;
    precision = Math.max((window.devicePixelRatio || 1) - 1, 0);
    offset = -1 * (Math.abs(imgHeight - wrapperHeight) * amount);

    img.style.transform = 'translate3d(-50%, ' + offset.toFixed(precision) + 'px, 0)';
  }

  function recalcAll() {
    var i;
    for (i = 0; i < parallaxElements.length; i += 1) {
      updateParallaxElementSize(parallaxElements[i]);
    }
  }

  function updateVisible() {
    var i;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    for (i = 0; i < parallaxElements.length; i += 1) {
      updateParallaxElementPosition(parallaxElements[i], viewportHeight);
    }
  }

  function queueScrollUpdate() {
    if (ticking) {
      return;
    }
    ticking = true;
    window.requestAnimationFrame(function () {
      updateVisible();
      ticking = false;
    });
  }

  function queueRecalc() {
    if (resizeTicking) {
      return;
    }
    resizeTicking = true;
    window.requestAnimationFrame(function () {
      recalcAll();
      updateVisible();
      resizeTicking = false;
    });
  }

  function onImageLoad(event) {
    if (event && event.target && event.target.closest && event.target.closest('.parallax')) {
      queueRecalc();
    }
  }

  window.addEventListener('scroll', queueScrollUpdate, { passive: true });
  window.addEventListener('resize', queueRecalc);
  window.addEventListener('orientationchange', queueRecalc);
  window.addEventListener('load', queueRecalc);
  document.addEventListener('DOMContentLoaded', queueRecalc);

  parallaxElements.forEach(function (element) {
    var img = element.querySelector('img');
    if (!img) {
      return;
    }
    if (!img.complete) {
      img.addEventListener('load', onImageLoad);
    }
  });

  queueRecalc();
}());
